export const STOCK_TAB_QUERY_KEYS = ['inventario', 'movimientos', 'controles'];

export const stockTabIndexFromQuery = (tab) => {
  if (tab == null || tab === '') return null;
  const n = Number(tab);
  if (Number.isFinite(n) && n >= 0 && n < STOCK_TAB_QUERY_KEYS.length) return n;
  const map = { inventario: 0, movimientos: 1, controles: 2, controls: 2 };
  return map[String(tab).toLowerCase()] ?? null;
};

export const stockInventarioPath = (tabKey = 'inventario') =>
  `/admin/stock?tab=${tabKey}`;

/** Ruta al panel de control (edición o solo lectura). */
export const stockControlSessionPath = (sessionId, { viewOnly = false } = {}) => {
  const params = new URLSearchParams({ session: String(sessionId) });
  if (viewOnly) params.set('view', 'readonly');
  return `/admin/stock/control?${params.toString()}`;
};
